var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-9);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-9 {\n        fill: url(#GradientFill_3-8);\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33 {\n        stroke-width: 0px;\n      }\n\n      .cls-10 {\n        fill: url(#GradientFill_3-5);\n      }\n\n      .cls-11 {\n        fill: url(#GradientFill_3-7);\n      }\n\n      .cls-12 {\n        fill: url(#GradientFill_3-6);\n      }\n\n      .cls-13 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-14 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-34 {\n        fill: url(#GradientFill_3-14);\n      }\n\n      .cls-35 {\n        fill: url(#GradientFill_3-19);\n      }\n\n      .cls-36 {\n        fill: url(#GradientFill_3-29);\n      }\n\n      .cls-37 {\n        fill: url(#GradientFill_3-24);\n      }\n\n      .cls-15 {\n        fill: url(#GradientFill_3);\n      }\n\n      .cls-16 {\n        fill: url(#GradientFill_3-25);\n      }\n\n      .cls-17 {\n        fill: url(#GradientFill_3-27);\n      }\n\n      .cls-18 {\n        fill: url(#GradientFill_3-23);\n      }\n\n      .cls-19 {\n        fill: url(#GradientFill_3-22);\n      }\n\n      .cls-20 {\n        fill: url(#GradientFill_3-31);\n      }\n\n      .cls-21 {\n        fill: url(#GradientFill_3-28);\n      }\n\n      .cls-22 {\n        fill: url(#GradientFill_3-26);\n      }\n\n      .cls-23 {\n        fill: url(#GradientFill_3-20);\n      }\n\n      .cls-24 {\n        fill: url(#GradientFill_3-21);\n      }\n\n      .cls-25 {\n        fill: url(#GradientFill_3-30);\n      }\n\n      .cls-26 {\n        fill: url(#GradientFill_3-16);\n      }\n\n      .cls-27 {\n        fill: url(#GradientFill_3-18);\n      }\n\n      .cls-28 {\n        fill: url(#GradientFill_3-17);\n      }\n\n      .cls-29 {\n        fill: url(#GradientFill_3-10);\n      }\n\n      .cls-30 {\n        fill: url(#GradientFill_3-11);\n      }\n\n      .cls-31 {\n        fill: url(#GradientFill_3-13);\n      }\n\n      .cls-32 {\n        fill: url(#GradientFill_3-12);\n      }\n\n      .cls-33 {\n        fill: url(#GradientFill_3-15);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.16,
    x2: 25,
    y2: 0.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 19.04,
    y1: 50.16,
    x2: 19.04,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 19.04,
    y1: 50.16,
    x2: 19.04,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 19.04,
    y1: 50.16,
    x2: 19.04,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-5",
    "data-name": "GradientFill 3",
    x1: 19.04,
    y1: 50.16,
    x2: 19.04,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.56,23.45c.16-.43.28-.87.37-1.31.11.37.27.84.49,1.42l.72,1.9h-2.32l.75-2.01ZM18.46,21.42l-2.63,6.86h.96l.75-2.08h2.87l.8,2.08h1.03l-2.81-6.86h-.98Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-6",
    "data-name": "GradientFill 3",
    x1: 18.06,
    y1: 50.16,
    x2: 18.06,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-7",
    "data-name": "GradientFill 3",
    x1: 25.52,
    x2: 25.52,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-8",
    "data-name": "GradientFill 3",
    x1: 25.52,
    x2: 25.52,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-9",
    "data-name": "GradientFill 3",
    x1: 25.52,
    x2: 25.52,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-10",
    "data-name": "GradientFill 3",
    x1: 25.52,
    x2: 25.52,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M23.84,25.11h1.59c.44,0,.77.04,1,.11.23.08.41.21.54.4.13.19.2.41.2.67,0,.22-.05.41-.14.58-.09.17-.21.3-.35.38-.14.09-.32.15-.52.19-.12.02-.32.03-.62.03h-1.71v-2.36ZM23.84,22.23h1.37c.49,0,.84.03,1.04.1.2.07.36.18.47.35.11.17.16.37.16.6,0,.24-.06.44-.18.6-.12.16-.29.27-.52.34-.17.05-.46.08-.86.08h-1.48v-2.07ZM22.93,21.42v6.86h2.61c.44,0,.8-.04,1.11-.11.3-.08.55-.19.75-.34.2-.15.37-.36.5-.64.14-.28.2-.57.2-.9,0-.4-.11-.75-.33-1.04-.22-.29-.54-.5-.96-.62.32-.16.56-.37.72-.63.16-.26.24-.54.24-.83,0-.31-.09-.62-.27-.91-.18-.29-.43-.5-.74-.64-.32-.14-.74-.21-1.26-.21h-2.57Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-11",
    "data-name": "GradientFill 3",
    x1: 25.61,
    x2: 25.61,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-12",
    "data-name": "GradientFill 3",
    x1: 31.78,
    x2: 31.78,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-13",
    "data-name": "GradientFill 3",
    x1: 31.78,
    x2: 31.78,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-14",
    "data-name": "GradientFill 3",
    x1: 31.78,
    x2: 31.78,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-15",
    "data-name": "GradientFill 3",
    x1: 31.78,
    x2: 31.78,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M30.47,21.54c-.38.16-.67.39-.86.69-.2.3-.3.62-.3.97,0,.32.08.6.24.85.16.25.4.47.73.64.25.13.69.28,1.32.43.63.15,1.04.26,1.22.33.29.11.49.24.62.41.12.16.19.35.19.56s-.06.41-.19.59c-.13.18-.33.32-.59.42-.27.1-.57.15-.92.15-.39,0-.74-.07-1.05-.2-.31-.14-.54-.31-.69-.53-.15-.22-.24-.5-.28-.85l-.86.08c.01.46.14.87.38,1.23.24.36.57.63.99.81.42.18.94.27,1.56.27.49,0,.93-.09,1.32-.27.39-.18.69-.43.9-.75.21-.32.31-.67.31-1.03s-.09-.69-.28-.98c-.19-.28-.49-.52-.88-.7-.27-.13-.78-.27-1.52-.44-.74-.17-1.19-.33-1.37-.49-.18-.16-.27-.36-.27-.61,0-.28.12-.53.37-.73.25-.2.65-.3,1.2-.3s.93.11,1.2.33c.27.22.43.55.48.98l.87-.07c-.01-.4-.13-.76-.34-1.08-.21-.32-.51-.56-.9-.72-.39-.16-.84-.25-1.34-.25-.46,0-.88.08-1.26.23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-16",
    "data-name": "GradientFill 3",
    x1: 32.89,
    y1: 50.16,
    x2: 32.89,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-17",
    "data-name": "GradientFill 3",
    x1: 25.43,
    x2: 25.43,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-18",
    "data-name": "GradientFill 3",
    x1: 25.43,
    x2: 25.43,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-19",
    "data-name": "GradientFill 3",
    x1: 25.43,
    x2: 25.43,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-20",
    "data-name": "GradientFill 3",
    x1: 25.43,
    x2: 25.43,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M12.79,24.77c0-6.97,5.67-12.63,12.64-12.63s12.64,5.67,12.64,12.63-5.67,12.64-12.64,12.64-12.64-5.67-12.64-12.64M10.74,24.77c0,8.1,6.59,14.69,14.69,14.69s14.69-6.59,14.69-14.69-6.59-14.69-14.69-14.69-14.69,6.59-14.69,14.69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-21",
    "data-name": "GradientFill 3",
    x1: 25.5,
    x2: 25.5,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-22",
    "data-name": "GradientFill 3",
    x1: 40.94,
    y1: 50.16,
    x2: 40.94,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-23",
    "data-name": "GradientFill 3",
    x1: 40.94,
    y1: 50.16,
    x2: 40.94,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-24",
    "data-name": "GradientFill 3",
    x1: 40.94,
    y1: 50.16,
    x2: 40.94,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-25",
    "data-name": "GradientFill 3",
    x1: 40.94,
    y1: 50.16,
    x2: 40.94,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M38.36,13.03c-.4.4-.4,1.05,0,1.45.03.03,3.4,3.49,3.4,9.96s-3.39,10.24-3.43,10.27c-.39.41-.37,1.06.05,1.45.2.18.45.28.7.28.27,0,.55-.11.75-.32.16-.17,3.98-4.32,3.98-11.68s-3.84-11.25-4.01-11.42c-.2-.2-.46-.29-.72-.29s-.53.1-.73.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-26",
    "data-name": "GradientFill 3",
    x1: 43.55,
    y1: 50.16,
    x2: 43.55,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-27",
    "data-name": "GradientFill 3",
    x1: 9.37,
    y1: 50.16,
    x2: 9.37,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-28",
    "data-name": "GradientFill 3",
    x1: 9.37,
    y1: 50.16,
    x2: 9.37,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-29",
    "data-name": "GradientFill 3",
    x1: 9.37,
    y1: 50.16,
    x2: 9.37,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-30",
    "data-name": "GradientFill 3",
    x1: 9.37,
    y1: 50.16,
    x2: 9.37,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M10.5,13.02c-.16.16-4.01,4.04-4.01,11.42s3.82,11.5,3.98,11.68c.2.22.47.32.75.32.25,0,.5-.09.7-.28.41-.39.44-1.04.05-1.45-.03-.04-3.43-3.77-3.43-10.27s3.35-9.91,3.4-9.96c.4-.4.4-1.05,0-1.45-.2-.2-.47-.3-.73-.3s-.52.1-.72.29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-31",
    "data-name": "GradientFill 3",
    x1: 6.82,
    y1: 50.16,
    x2: 6.82,
    y2: 0.06,
    xlinkHref: "#GradientFill_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25,3.06C12.9,3.06,3.06,12.9,3.06,25s9.84,21.94,21.94,21.94,21.94-9.84,21.94-21.94S37.1,3.06,25,3.06M25,50C11.21,50,0,38.79,0,25S11.21,0,25,0s25,11.21,25,25-11.21,25-25,25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M18.46,21.42l-2.63,6.86h.96l.75-2.08h2.87l.8,2.08h1.03l-2.81-6.86h-.98ZM18.56,23.45c.16-.43.28-.87.37-1.31.11.37.27.84.49,1.42l.72,1.9h-2.32l.75-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M18.46,21.42l-2.63,6.86h.96l.75-2.08h2.87l.8,2.08h1.03l-2.81-6.86h-.98ZM18.56,23.45c.16-.43.28-.87.37-1.31.11.37.27.84.49,1.42l.72,1.9h-2.32l.75-2.01Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.56,23.45c.16-.43.28-.87.37-1.31.11.37.27.84.49,1.42l.72,1.9h-2.32l.75-2.01ZM18.46,21.42l-2.63,6.86h.96l.75-2.08h2.87l.8,2.08h1.03l-2.81-6.86h-.98Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 10.34,
    y: 21.85,
    width: 15.45,
    height: 16.51
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M22.93,21.42v6.86h2.62c.44,0,.8-.04,1.11-.11.3-.08.55-.19.75-.34.2-.15.37-.36.5-.64.14-.28.2-.57.2-.9,0-.4-.11-.74-.33-1.04-.22-.29-.54-.5-.96-.62.32-.16.56-.37.72-.63.16-.26.24-.54.24-.83,0-.31-.09-.62-.27-.91-.18-.29-.43-.5-.74-.64-.32-.14-.74-.21-1.26-.21h-2.57ZM23.84,22.23h1.37c.49,0,.84.03,1.04.1.2.06.36.18.47.35.11.17.16.37.16.6,0,.24-.06.44-.18.6-.12.16-.29.27-.52.34-.17.05-.46.08-.86.08h-1.48v-2.07ZM23.84,25.11h1.58c.44,0,.77.04,1,.11.23.08.41.21.54.4.13.19.2.41.2.67,0,.22-.05.41-.14.58-.09.17-.21.29-.35.38-.14.09-.31.15-.52.19-.12.02-.32.03-.62.03h-1.71v-2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.93,21.42v6.86h2.62c.44,0,.8-.04,1.11-.11.3-.08.55-.19.75-.34.2-.15.37-.36.5-.64.14-.28.2-.57.2-.9,0-.4-.11-.74-.33-1.04-.22-.29-.54-.5-.96-.62.32-.16.56-.37.72-.63.16-.26.24-.54.24-.83,0-.31-.09-.62-.27-.91-.18-.29-.43-.5-.74-.64-.32-.14-.74-.21-1.26-.21h-2.57ZM23.84,22.23h1.37c.49,0,.84.03,1.04.1.2.06.36.18.47.35.11.17.16.37.16.6,0,.24-.06.44-.18.6-.12.16-.29.27-.52.34-.17.05-.46.08-.86.08h-1.48v-2.07ZM23.84,25.11h1.58c.44,0,.77.04,1,.11.23.08.41.21.54.4.13.19.2.41.2.67,0,.22-.05.41-.14.58-.09.17-.21.29-.35.38-.14.09-.31.15-.52.19-.12.02-.32.03-.62.03h-1.71v-2.36Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.84,25.11h1.59c.44,0,.77.04,1,.11.23.08.41.21.54.4.13.19.2.41.2.67,0,.22-.05.41-.14.58-.09.17-.21.3-.35.38-.14.09-.32.15-.52.19-.12.02-.32.03-.62.03h-1.71v-2.36ZM23.84,22.23h1.37c.49,0,.84.03,1.04.1.2.07.36.18.47.35.11.17.16.37.16.6,0,.24-.06.44-.18.6-.12.16-.29.27-.52.34-.17.05-.46.08-.86.08h-1.48v-2.07ZM22.93,21.42v6.86h2.61c.44,0,.8-.04,1.11-.11.3-.08.55-.19.75-.34.2-.15.37-.36.5-.64.14-.28.2-.57.2-.9,0-.4-.11-.75-.33-1.04-.22-.29-.54-.5-.96-.62.32-.16.56-.37.72-.63.16-.26.24-.54.24-.83,0-.31-.09-.62-.27-.91-.18-.29-.43-.5-.74-.64-.32-.14-.74-.21-1.26-.21h-2.57Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 19.38,
    y: 21.85,
    width: 12.46,
    height: 16.51
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M30.47,21.54c-.38.16-.67.39-.86.69-.2.3-.3.62-.3.97,0,.32.08.6.24.85.16.26.4.47.73.64.25.13.69.28,1.32.43s1.04.26,1.22.33c.29.11.49.24.62.41.12.16.19.35.19.56s-.06.41-.19.59c-.13.18-.33.32-.59.42-.26.1-.57.15-.92.15-.39,0-.74-.07-1.05-.2-.31-.14-.54-.31-.69-.53-.15-.22-.24-.5-.28-.84l-.86.08c.01.46.14.87.38,1.23s.57.64.99.82c.42.18.94.27,1.56.27.49,0,.93-.09,1.32-.27.39-.18.69-.43.9-.75.21-.32.31-.67.31-1.03s-.1-.69-.29-.98c-.19-.28-.49-.52-.88-.7-.27-.13-.78-.27-1.52-.44-.74-.17-1.19-.33-1.37-.49-.18-.16-.27-.36-.27-.61,0-.28.12-.53.37-.73.25-.2.65-.3,1.2-.3s.93.11,1.2.33c.27.22.43.55.47.98l.87-.07c-.01-.4-.13-.76-.34-1.08-.21-.32-.51-.56-.9-.72-.39-.16-.84-.25-1.34-.25-.46,0-.88.08-1.26.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M30.47,21.54c-.38.16-.67.39-.86.69-.2.3-.3.62-.3.97,0,.32.08.6.24.85.16.26.4.47.73.64.25.13.69.28,1.32.43s1.04.26,1.22.33c.29.11.49.24.62.41.12.16.19.35.19.56s-.06.41-.19.59c-.13.18-.33.32-.59.42-.26.1-.57.15-.92.15-.39,0-.74-.07-1.05-.2-.31-.14-.54-.31-.69-.53-.15-.22-.24-.5-.28-.84l-.86.08c.01.46.14.87.38,1.23s.57.64.99.82c.42.18.94.27,1.56.27.49,0,.93-.09,1.32-.27.39-.18.69-.43.9-.75.21-.32.31-.67.31-1.03s-.1-.69-.29-.98c-.19-.28-.49-.52-.88-.7-.27-.13-.78-.27-1.52-.44-.74-.17-1.19-.33-1.37-.49-.18-.16-.27-.36-.27-.61,0-.28.12-.53.37-.73.25-.2.65-.3,1.2-.3s.93.11,1.2.33c.27.22.43.55.47.98l.87-.07c-.01-.4-.13-.76-.34-1.08-.21-.32-.51-.56-.9-.72-.39-.16-.84-.25-1.34-.25-.46,0-.88.08-1.26.23"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M30.47,21.54c-.38.16-.67.39-.86.69-.2.3-.3.62-.3.97,0,.32.08.6.24.85.16.25.4.47.73.64.25.13.69.28,1.32.43.63.15,1.04.26,1.22.33.29.11.49.24.62.41.12.16.19.35.19.56s-.06.41-.19.59c-.13.18-.33.32-.59.42-.27.1-.57.15-.92.15-.39,0-.74-.07-1.05-.2-.31-.14-.54-.31-.69-.53-.15-.22-.24-.5-.28-.85l-.86.08c.01.46.14.87.38,1.23.24.36.57.63.99.81.42.18.94.27,1.56.27.49,0,.93-.09,1.32-.27.39-.18.69-.43.9-.75.21-.32.31-.67.31-1.03s-.09-.69-.28-.98c-.19-.28-.49-.52-.88-.7-.27-.13-.78-.27-1.52-.44-.74-.17-1.19-.33-1.37-.49-.18-.16-.27-.36-.27-.61,0-.28.12-.53.37-.73.25-.2.65-.3,1.2-.3s.93.11,1.2.33c.27.22.43.55.48.98l.87-.07c-.01-.4-.13-.76-.34-1.08-.21-.32-.51-.56-.9-.72-.39-.16-.84-.25-1.34-.25-.46,0-.88.08-1.26.23"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 26.32,
    y: 21.56,
    width: 13.14,
    height: 17.07
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M10.74,24.77c0,8.1,6.59,14.69,14.69,14.69s14.69-6.59,14.69-14.69-6.59-14.69-14.69-14.69-14.69,6.59-14.69,14.69M12.79,24.77c0-6.97,5.67-12.64,12.64-12.64s12.64,5.67,12.64,12.64-5.67,12.64-12.64,12.64-12.64-5.67-12.64-12.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M10.74,24.77c0,8.1,6.59,14.69,14.69,14.69s14.69-6.59,14.69-14.69-6.59-14.69-14.69-14.69-14.69,6.59-14.69,14.69M12.79,24.77c0-6.97,5.67-12.64,12.64-12.64s12.64,5.67,12.64,12.64-5.67,12.64-12.64,12.64-12.64-5.67-12.64-12.64"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M12.79,24.77c0-6.97,5.67-12.63,12.64-12.63s12.64,5.67,12.64,12.63-5.67,12.64-12.64,12.64-12.64-5.67-12.64-12.64M10.74,24.77c0,8.1,6.59,14.69,14.69,14.69s14.69-6.59,14.69-14.69-6.59-14.69-14.69-14.69-14.69,6.59-14.69,14.69"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: -9.87,
    y: -5.36,
    width: 70.73,
    height: 70.73
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M38.36,13.03c-.4.4-.4,1.05,0,1.45.03.03,3.4,3.49,3.4,9.96s-3.39,10.24-3.43,10.27c-.39.41-.37,1.06.05,1.45.2.18.45.28.7.28.27,0,.55-.11.75-.32.16-.17,3.98-4.33,3.98-11.68s-3.84-11.25-4.01-11.42c-.2-.2-.46-.3-.72-.3s-.53.1-.73.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M38.36,13.03c-.4.4-.4,1.05,0,1.45.03.03,3.4,3.49,3.4,9.96s-3.39,10.24-3.43,10.27c-.39.41-.37,1.06.05,1.45.2.18.45.28.7.28.27,0,.55-.11.75-.32.16-.17,3.98-4.33,3.98-11.68s-3.84-11.25-4.01-11.42c-.2-.2-.46-.3-.72-.3s-.53.1-.73.3"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M38.36,13.03c-.4.4-.4,1.05,0,1.45.03.03,3.4,3.49,3.4,9.96s-3.39,10.24-3.43,10.27c-.39.41-.37,1.06.05,1.45.2.18.45.28.7.28.27,0,.55-.11.75-.32.16-.17,3.98-4.32,3.98-11.68s-3.84-11.25-4.01-11.42c-.2-.2-.46-.29-.72-.29s-.53.1-.73.3"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 36.48,
    y: 1.24,
    width: 14.12,
    height: 57.08
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M10.5,13.02c-.16.16-4.01,4.04-4.01,11.42s3.82,11.5,3.98,11.68c.2.22.47.32.75.32.25,0,.5-.09.7-.27.42-.39.44-1.04.05-1.45-.03-.04-3.43-3.77-3.43-10.27s3.35-9.91,3.4-9.96c.4-.4.4-1.05,0-1.45-.2-.2-.47-.3-.73-.3s-.52.1-.72.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M10.5,13.02c-.16.16-4.01,4.04-4.01,11.42s3.82,11.5,3.98,11.68c.2.22.47.32.75.32.25,0,.5-.09.7-.27.42-.39.44-1.04.05-1.45-.03-.04-3.43-3.77-3.43-10.27s3.35-9.91,3.4-9.96c.4-.4.4-1.05,0-1.45-.2-.2-.47-.3-.73-.3s-.52.1-.72.29"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M10.5,13.02c-.16.16-4.01,4.04-4.01,11.42s3.82,11.5,3.98,11.68c.2.22.47.32.75.32.25,0,.5-.09.7-.28.41-.39.44-1.04.05-1.45-.03-.04-3.43-3.77-3.43-10.27s3.35-9.91,3.4-9.96c.4-.4.4-1.05,0-1.45-.2-.2-.47-.3-.73-.3s-.52.1-.72.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: -0.24,
    y: 1.24,
    width: 14.12,
    height: 57.08
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbs);
export default __webpack_public_path__ + "static/media/Icon_ABS.fe5418069351811d2972cc7792921b3b.svg";
export { ForwardRef as ReactComponent };